import {
  type EffectRain,
  type EffectSunlight,
  EffectType,
  type SceneEffect,
} from '@types';

export function isSunlightEffect(data: SceneEffect): data is EffectSunlight {
  return data.type === EffectType.sunlight;
}
export function isRainEffect(data: SceneEffect): data is EffectRain {
  return data.type === EffectType.rain;
}
